export default __webpack_public_path__ + "static/media/45771222a779611209483236a0742109.svg";